import { authenticatedInstance } from '../index/index.service';
import { extractServiceErrorMessage } from '../shared/service-error.util';
import type {
  AdminMergeAuditPage,
  AdminMergeAuditQuery,
  AdminMergeAuditView,
} from 'shared-models/browser';

export type {
  AdminMergeAuditPage,
  AdminMergeAuditQuery,
  AdminMergeAuditView,
  AdminMergeKind,
  AdminMergeOrderlineSnapshot,
  AdminMergeTableSnapshot,
} from 'shared-models/browser';

class AdminMergeAuditService {
  async list(query: AdminMergeAuditQuery = {}): Promise<AdminMergeAuditPage> {
    try {
      const response = await authenticatedInstance.get<AdminMergeAuditPage>('/payments/admin/merge-movements', {
        params: query,
      });
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }

  async getDetail(id: number): Promise<AdminMergeAuditView> {
    try {
      const response = await authenticatedInstance.get<AdminMergeAuditView>(`/payments/admin/merge-movements/${id}`);
      return response.data;
    } catch (error: unknown) {
      throw new Error(extractServiceErrorMessage(error, ''));
    }
  }
}

export const adminMergeAuditService = new AdminMergeAuditService();
